module.exports = __webpack_public_path__ + "media/images/icons/badge-00e141d27841994d36b10e45103386f3.svg";